

module Meevo.Components.Compensation {

    interface employeeOverride {
        employeeUserId: string,
        displayName: string,
        isPercent: boolean,
        fee: number,
        overrideModel?: any
    }

    class CommissionsOverrideModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            'employees'
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public employees: Array<employeeOverride>) {

        }

        apply = () => {
            var vm = this;

            this.employees = _.filter(this.employees, function (item: employeeOverride) {
                delete item.overrideModel;
                return item.employeeUserId !== '';
            });
            
            this.$mdDialog.hide({ status: true, employees: this.employees });
        };

        cancel = () => {
            this.$mdDialog.hide({ status: false });
        };

        /**
         * Click add for add row inputs
         * */
        public addRowOverride(): void {
            let overridesRowModel: employeeOverride = {
                employeeUserId: '',
                displayName: '',
                isPercent: true,
                fee: 0
            };

            this.employees.push(overridesRowModel);
        }
        
        /**
         * Click remove icon
         * Remove item from Discounts
         * @param item - item row override for delete
         * @param arr - list items
         * */
        public removeRow(item: employeeOverride): void {
            let index = this.employees.indexOf(item);
            this.employees.splice(index, 1);
        }

        /**
         * Select item for override
         * @param item - item for override
         */
        public changeOverrideItem(item: employeeOverride): void {
            if (item.overrideModel.id) {
                item.employeeUserId = item.overrideModel.id;
                item.displayName = item.overrideModel.displayName;
            }
        }
        
        /**
         * Pre Process list for remove prev override item
         * @param responseData
         * @param requestData
         */
        public preProcessOverrideItems(responseData, requestData): any {
            let list = this.employees;

            // filter 
            if (list.length > 1) {
                let filtered: Array<Object> = _.reject(responseData, function (itemService: any): any {
                    return _.find(list, function (item: any) {
                        return item.employeeUserId === itemService.id
                    })
                });

                // Change original array. Because responseData = filtered; don't change original variable
                responseData.length = 0;
                responseData.push.apply(responseData, filtered);
            }

            return responseData;
        }
    }

    angular.module("meevo.components.compensation")
        .controller("meevo.components.compensation.CommissionsOverrideModalController", CommissionsOverrideModalController);
}